// @flow

import React, { PureComponent } from "react";
import styled, { keyframes } from "styled-components";

import color from "../ColorPalette";

const pulseAnimation = keyframes`
  0% {
    fill: ${color("grey", "100")};
  }

  50% {
    fill: ${color("grey", "000")};
  }

  100% {
    fill: ${color("grey", "100")};
  }
`;

const SVGContainer = styled.div`
  width: 100%;
  background-color: white;
  overflow: hidden;
  height: 100%;
`;

const SVG = styled.svg`
  display: block;
  width: 1366px;
  height: 100%;

  rect.pulse {
    animation: ${pulseAnimation} 1.25s infinite;
  }
`;

export default class TracksAZMask extends PureComponent<*> {
  render() {
    return (
      <SVGContainer data-qa-label="tracksAZMask">
        <SVG>
          <g fill="none" fillRule="evenodd">
            <rect width="518" height="480" fill={color("white", "100")} />
            <rect
              width="12"
              height="8"
              x="12"
              y="58"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="86"
              height="8"
              x="12"
              y="24"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="120"
              height="8"
              x="12"
              y="98"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="120"
              height="8"
              x="12"
              y="146"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="136"
              height="8"
              x="12"
              y="194"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="12"
              height="8"
              x="12"
              y="234"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="82"
              height="8"
              x="12"
              y="274"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="130"
              height="8"
              x="12"
              y="322"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="12"
              height="8"
              x="12"
              y="362"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="116"
              height="8"
              x="12"
              y="402"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect
              width="132"
              height="8"
              x="12"
              y="450"
              fill={color("grey", "100")}
              rx="1"
              className="pulse"
            />
            <rect width="518" height="1" y="77" fill={color("grey", "200")} />
            <rect width="518" height="1" y="125" fill={color("grey", "200")} />
            <rect width="518" height="1" y="173" fill={color("grey", "200")} />
            <rect width="518" height="1" y="221" fill={color("grey", "200")} />
            <rect width="518" height="1" y="253" fill={color("grey", "200")} />
            <rect width="518" height="1" y="301" fill={color("grey", "200")} />
            <rect width="518" height="1" y="349" fill={color("grey", "200")} />
            <rect width="518" height="1" y="381" fill={color("grey", "200")} />
            <rect width="518" height="1" y="429" fill={color("grey", "200")} />
          </g>
        </SVG>
      </SVGContainer>
    );
  }
}
